import { Box, Link } from '@mui/material';
import React from 'react';

import { EvoachLinkify } from '../EvoachLinkify';
import { CardImageEnum, ObjectCardImage } from '../ObjectCard';

export interface ProductTourStepContentProps {
  displayWide?: boolean;
  // title of Popover
  title: string;
  // shown below title
  texts?: string[];
  // optional illustration, to be shown on the right side of title
  descriptionIllustration?: CardImageEnum;
  // video, image and children can be used to display content below the description
  descriptionIllustrationSrc?: string;
  // video, image and children can be used to display content below the description
  youtubeEmbedURL?: string;
  image?: CardImageEnum;
  imageSrc?: string;
  children?: React.ReactNode;
  // link to close product tour, and go to url if given
  exitLink?: { linkText: string; callback: () => void };
}

export const ProductTourStepContent = ({
  displayWide = false,
  title,
  texts,
  descriptionIllustrationSrc,
  youtubeEmbedURL,
  imageSrc,
  children,
  exitLink,
}: ProductTourStepContentProps) => (
  <Box
    color="primary.contrastText"
    sx={{
      width: displayWide ? '100%' : '370px',
      maxWidth: displayWide ? '800px' : '370px',
    }}
  >
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginBottom={displayWide ? '0px' : '20px'}
      >
        <Box
          sx={{ typography: displayWide ? 'h4' : 'h5', whiteSpace: 'pre-wrap' }}
        >
          {title}
        </Box>
        {descriptionIllustrationSrc && displayWide && (
          <ObjectCardImage imageSrc={descriptionIllustrationSrc} width={200} />
        )}
      </Box>
      <Box sx={{ marginBottom: displayWide ? '50px' : '25px' }}>
        {texts &&
          texts.length > 0 &&
          texts.map((text, index) => {
            return (
              <Box
                key={index}
                sx={{
                  typography: 'body1',
                  fontWeight: 400,
                  marginBottom: '1em',

                  whiteSpace: 'pre-wrap',
                }}
              >
                <EvoachLinkify>{text}</EvoachLinkify>
              </Box>
            );
          })}
      </Box>
      {youtubeEmbedURL && (
        <Box
          display="flex"
          justifyContent="center"
          margin={displayWide ? '20px' : '0'}
        >
          <iframe
            width={displayWide ? '500' : '370'}
            height={displayWide ? '281' : '208'}
            src={youtubeEmbedURL}
            title="Evoach Product Tour"
            allowFullScreen
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        </Box>
      )}

      {imageSrc && (
        <Box>
          <ObjectCardImage imageSrc={imageSrc} imageSize={300} />
        </Box>
      )}
      {children && <Box>{children}</Box>}
      {exitLink && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginTop="15px"
          marginBottom="15px"
        >
          <Link
            onClick={exitLink.callback}
            color="secondary"
            sx={{ typography: 'body1', cursor: 'pointer' }}
          >
            {exitLink.linkText}
          </Link>
        </Box>
      )}
      <Box height="15px"></Box>
    </>
  </Box>
);
